import './Main.css'
function Main() {
    const style_255width = {
        width: '255px'
    }
    const style_space_height = {
        height: '50px'
    }
    const style_shape_left = {
        width:'100%',
        float: 'left'
    }
    const style_shape_right = {
        width:'100%',
        float: 'right'
    }

    const pic_1 ={
        backgroundImage: 'url("images/japanese.jpg")'
    }
    const pic_2 ={
        backgroundImage: 'url("images/experience.jpg")'
    }
    const pic_3 ={
        backgroundImage: 'url("images/idea.jpg")'
    }
    const pic_4 ={
        backgroundImage: 'url("images/resource.jpg")'
    }

    const c_1 = {
        backgroundColor: '#00b0f0'
    }
    const c_2 = {
        backgroundColor: '#eb7766'
    }
    const c_3 = {
        backgroundColor: '#90c226'
    }
    const c_4 = {
        backgroundColor: '#00b050'
    }

    return (
        <main>
            <div className="banner center">
                <div className="left">
                    <div className="content">
                        <div className="span">
                            チーム一丸！<br />目標へ突き進め！<br />壁を越え、新たな高みを創ろう！
                        </div>
                    </div>
                </div>
                <div className="right">
                    <div className="custom-image radius"></div>
                </div>
            </div>

            <div className="tagboard center">
                <div style={style_255width}>
                    <div className="img radius" style={pic_1}>
                    </div>
                    <div className="center">
                        日本語ができる技術者集団
                    </div>
                </div>

                <div style={style_255width}>
                    <div className="img radius" style={pic_2}>
                    </div>
                    <div className="center">
                        豊富な開発経験
                    </div>
                </div>

                <div style={style_255width}>
                    <div className="img radius" style={pic_3}>
                    </div>
                    <div className="center">
                        顧客第一を考えた提案力
                    </div>
                </div>
                <div style={style_255width}>
                    <div className="img radius" style={pic_4}>
                    </div>
                    <div className="center">
                        柔軟にリソース調整が可能
                    </div>
                </div>
            </div>

            <div className="vision center">
                <div className="block center radius">
                    <div className="content">
                        <div className="title">ビジョン</div>
                        <div>トップレベルのデジタルソリューションプロバイダーになれる。</div>
                        <div>社員とその家族に喜びと幸福をもたらす企業になれる。</div>
                    </div>
                    <div className="content img center">
                        <img src="images/vision.jpg" width="160" height="180" alt="" />
                    </div>
                </div>

                <div className="block center radius">
                    <div className="content">
                        <div className="title">ミッション</div>
                        <div>企業へ欠かせないデジタルソリューションを提供する。</div>
                        <div>創造性と技術を活用して企業の持続的に発展を支援する。</div>
                    </div>
                    <div className="content img center">
                        <img src="images/mission.jpg" width="160" height="180" alt=""/>
                    </div>
                </div>
            </div>

            <div className="values center">
                <div className="block">
                    <div className="title center">
                        <div className="center">我々の価値観</div>
                    </div>
                    <div>
                        <div className="img center">
                            <img src="images/values.jpg" width="260" height="260" alt=""/>
                        </div>
                        <div className="content">
                            <div className="radius center" style={c_1}>
                                真に顧客の視点に立って問題を考え、<br />顧客の声に真摯に耳を傾け、顧客のニーズを把握する。</div>
                            <div className="radius center" style={c_2}>
                                チームワークは一番重要であり、一緒に努力し、<br />お互いの意見を尊重し合うことでチームを成長させる。</div>
                            <div className="radius center" style={c_3}>
                                論理を重視し、法令を遵守する。<br />公平公正で信頼できる会社を構築する。</div>
                            <div className="radius center" style={c_4}>
                                顧客により高い付加価値を提供し、<br />未知の領域への好奇心を常に持ち、自己挑戦を続ける。</div>
                        </div>
                    </div>
                </div>
            </div>

            <div style={style_space_height}></div>
            <div className="center">
                <div className="shape-left" style={style_shape_left}></div>
                <div className="shape-right" style={style_shape_right}></div>
            </div>
        </main>
    );
}

export default Main;